export default __webpack_public_path__ + "static/media/treat-yourself-2048w.4b01d419.avif";